<template>
    <div class="md-testimonial rating-star">
        <i
            v-for="i in maxRating"
            @click="setLevel(i)"
            :class="{
                light: score >= i
            }"
            :key="i"
            class="iconfont icon-star-fill"
        ></i>
    </div>
</template>

<script>
export default {
    emits: ['star'],
    name: 'rating-star',
    props: {
        maxRating: {
            type: Number,
            default: 5
        },
        score: {
            type: Number,
            default: 0
        }
    },
    methods: {
        setLevel(n) {
            this.$emit('star', n);
        }
    }
};
</script>

<style lang="scss">
.md-testimonial.rating-star {
    margin-left: 16px;
    font-size: 0;
    line-height: 40px;
    .icon-star-fill {
        font-size: 18px;
        margin-right: 8px;
        color: #c9c9c9;
        cursor: pointer;
        &.light {
            color: #f3ab1a;
        }
    }
}
</style>
